export class BaseImageryProvider {
    hasDataForTile(x, y, zoomLevel) {
        const tileNumX = this.tilingScheme.getNumberOfXTilesAtLevel(zoomLevel);
        const tileNumY = this.tilingScheme.getNumberOfYTilesAtLevel(zoomLevel);
        // Check if the request tile coordinate actually exists in the tiling scheme
        const tileOutOfBounds = x < 0 || x >= tileNumX || y < 0 || y >= tileNumY;
        // Check if the requested tile is inside the dataset's bounding box area
        const tileRect = this.tilingScheme.tileXYToRectangle(x, y, zoomLevel);
        const boxIntersect = this.region.intersects(tileRect);
        // Check if any data is available at the requested zoom level
        const zoomAvailable = zoomLevel >= this.minLevel && zoomLevel <= this.maxLevel;
        return !tileOutOfBounds && boxIntersect && zoomAvailable;
    }
    canRefine(x, y, zoomLevel) {
        return this.hasDataForTile(x, y, zoomLevel) && zoomLevel !== this.maxLevel;
    }
}
